export default __webpack_public_path__ + "static/media/3_006.ca980e55.png";